<template>
    <div style="text-align: center">
        <template>
            <div class="mt-4">
                <button v-if="fileExists" class="btn btn-default" @click="download">Download Enrollment File</button>
            </div>
        </template>
    </div>
</template>
<script>
import {uploadEnrollmentsService} from './upload-enrollments-service.js'
export default {
    props: ["item"],
    computed: {
    },
    data() {
        return {
            fileExists: false,
        }
    },
    created (){
        this.load();
    }, 
    methods: {
        async load() {
            this.fileExists = await uploadEnrollmentsService.checkIfFileExists(this.item.employerId,this.item.actionItemId);             
        },
        async download() {               
            this.busy = true;
            await romeApi.download(`employer/${this.item.employerId}/enrollment/download/latest/${this.item.actionItemId}`);           
            this.busy = false;     
        },
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/QaEnrollments.vue